<div class="root">
  <div class="viewport" #viewport>
    @for (item of value(); track $index) {
      <div class="viewport-item">
        <ng-container *ngTemplateOutlet="itemTemplate(); context: { $implicit: item }" />
      </div>
    }
  </div>

  @if (showNavigators()) {
    @if (canScrollPrev()) {
      <button type="button" class="nav nav-prev" aria-label="Précédent" (click)="scrollByOne(-1)">
        <span class="material-symbols">chevron_left</span>
      </button>
    }
    @if (canScrollNext()) {
      <button type="button" class="nav nav-next" aria-label="Suivant" (click)="scrollByOne(1)">
        <span class="material-symbols">chevron_right</span>
      </button>
    }
  }

  @if (showIndicators() && pageCount() > 1) {
    <div class="indicators">
      @for (page of pages(); track page) {
        <button
          type="button"
          class="indicator"
          [class.active]="page === activePage()"
          [attr.aria-label]="'Aller à la page ' + (page + 1)"
          (click)="scrollToPage(page)"></button>
      }
    </div>
  }
</div>
